<template>
  <v-widget
    :title="$t('Group Name')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-form
        dense
      >
        <v-text-field
          v-model="group.name"
          :error-count="group.displayErrors('name').length"
          :error-messages="group.displayErrors('name')"
          :label="$t('Name')"
          outline
        />

        <v-text-field
          v-model="group.code"
          :error-count="group.displayErrors('code').length"
          :error-messages="group.displayErrors('code')"
          :label="$t('Code')"
          outline
        />

      </v-form>
    </div>
  </v-widget>
</template>

<script>
export default {
  name: 'CustomerGroupName',

  props: {
    group: {
      type: Object,
      required: true
    }
  },

  watch: {
    'group.name': function (value) {
      if (this.group.id) {
        return
      }

      this.group.code = value.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '')
    }
  }
}
</script>
